import { render } from "./AboutUs.vue?vue&type=template&id=7ab6721a&scoped=true&bindings={}"
import script from "./AboutUs.vue?vue&type=script&lang=ts"
export * from "./AboutUs.vue?vue&type=script&lang=ts"

import "./AboutUs.vue?vue&type=style&index=0&id=7ab6721a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7ab6721a"

export default script